import { createXKey } from './utils';
import { ElementHighlight } from './elementHighlight';
export function ElementHighlightByX(options) {
  return ElementHighlight(Object.assign(Object.assign({}, options), {
    createGroup: createXKey
  }));
}